import React, { useEffect, useState } from "react";
import AddDvrReport from "./AddDvrReport";
import {
  RowDetailState,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import { Dashboard as DashboardLayout } from "layouts";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  PagingPanel,
  SearchPanel,
  Toolbar,
} from "@devexpress/dx-react-grid-material-ui";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import { Grid, Paper, Typography, withStyles } from "@material-ui/core";
import { SALES_DVR_REPORT, GET_MY_DEALERS_SALE } from "../queries";
import { Subscription } from "react-apollo";
import { useQuery } from "@apollo/client";
import EditDealerDetails from "pages/Administration/MyDealers/EditDealerDetails";
import DvrReportDetail from "./DvrReportDetail";
import auth from "Auth";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: "none",
  },
  root: {
    padding: theme.spacing(),
  },
  item: {
    height: "100%",
  },
  marginFix: {
    marginTop: 19,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
  },
  loadingbox: {
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "-50% -50%",
  },
});

function DvrReport({ classes, match }) {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
      maxWidth: 300,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }));

  const [queryData, setQueryData] = useState();
  const [edit, setEdit] = useState();
  const [selectedFieldMultiple, setSelectedFieldMultiple] = useState([]);

  // Fetch the dealers assigned to the logged-in sales rep so the DVR report
  // can be scoped to "assigned dealers + the rep's own profile".
  const { data: salesData } = useQuery(GET_MY_DEALERS_SALE, {
    notifyOnNetworkStatusChange: true,
    variables: { profile_id: auth.getSub() },
    fetchPolicy: "cache-and-network",
  });

  const dvrProfileIds = [
    ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
    auth.getSub(),
  ];

  const { params } = match;

  useEffect(() => {
    if (params?.id) {
      setEdit(params?.id);
    }
  }, [params?.id]);

  const [columns] = useState([
    { name: "created_at", title: "Date Added" },
    {
      name: "name",
      title: "Dealer Name",
      getCellValue: (row) => row?.profiles?.name || "",
    },
    {
      name: "brand",
      title: "Brand",
      getCellValue: (row) =>
        <EditDealerDetails item={row} /> ? (
          <EditDealerDetails item={row?.profiles} />
        ) : undefined,
    },
    {
      name: "email",
      title: "Email",
      getCellValue: (row) => row?.profiles?.email || "",
    },
  ]);

  const [searchValue, setSearchValue] = useState("");
  const [selectedField, setSelectedField] = useState("Date Added");

  const brandOptions = {
    "Carolina Skiff": "has_skiff",
    "Sea Chaser": "has_seachaser",
    "Fun Chaser": "has_funchaser",
  };

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  const RowDetail = ({ row }) => {
    if (queryData) {
      const rowData = queryData?.find((rows) => rows?.id === row?.id);
      return (
        <div>
          <DvrReportDetail
            isDisplay={true}
            isEdit={true}
            row={rowData}
            type="dealer"
          />
        </div>
      );
    }
    return <div>Row details not available.</div>;
  };

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const handleFieldChange = (selectedField) => {
    setSelectedField(selectedField);
    setSearchValue("");
    setSelectedFieldMultiple([]);
  };

  const handleFieldChangeMultiple = (selectedField) => {
    setSelectedFieldMultiple(selectedField);
    setSearchValue("");
  };

  const FieldMultipleDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="mutiple-chip-label">Brand</InputLabel>
        <Select
          labelId="mutiple-chip-label"
          id="mutiple-chip-select"
          multiple
          value={selectedField}
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected?.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields?.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const DealerNameDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="dealer-company-label">Dealer Name</InputLabel>
        <Select
          labelId="dealer-company-label"
          id="dealer-company-select"
          multiple
          value={selectedField}
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  return (
    <div>
      <DashboardLayout>
        <div className="sectionContainer dvr-header">
          <Typography gutterBottom variant="h4" className="title">
            <span>DEALER DVR REPORT</span>
          </Typography>
        </div>

        <Paper className={classes.paper} style={{ margin: "3em" }}>
          <Grid container>
            {auth.role === "Sales" || auth.role === "sales" || edit ? (
              <AddDvrReport editId={edit} />
            ) : null}
            {edit ? null : (
              <div className={classes.gridContainer}>
                <Subscription
                  subscription={SALES_DVR_REPORT}
                  skip={salesData === undefined}
                  variables={{ profileIds: dvrProfileIds }}
                  onSubscriptionData={(data) => {
                    setQueryData(
                      data?.subscriptionData?.data?.dealer_dvr_report
                    );
                  }}
                >
                  {({ data, loading, error }) => {
                    // if (loading) return <p className="loadingbox" style={{textAlign: "center"}}>Loading...</p>;
                    if (loading)
                      return (
                        <p
                          className="loadingbox"
                          style={{ textAlign: "center" }}
                        >
                          Loading...
                        </p>
                      );
                    if (error) {
                      toast.error("Error");
                    }
                    const filteredRows = data?.dealer_dvr_report?.filter(
                      (row) => {
                        let name;
                        if (selectedField === "Date Added") {
                          name =
                            row?.[
                              columns?.find((e) => e?.title === selectedField)
                                ?.name
                            ]?.toLowerCase();
                        } else if (
                          selectedField !== "Brand" &&
                          selectedField !== "Dealer Name"
                        ) {
                          name =
                            row?.profiles?.[
                              columns?.find((e) => e?.title === selectedField)
                                ?.name
                            ]?.toLowerCase();
                        } else if (selectedField === "Brand") {
                          return (
                            selectedFieldMultiple.length === 0 ||
                            selectedFieldMultiple.some(
                              (brandName) =>
                                row?.profiles?.[brandOptions[brandName]]
                            )
                          );
                        } else if (selectedField === "Dealer Name") {
                          return (
                            selectedFieldMultiple.length === 0 ||
                            selectedFieldMultiple.includes(row?.profiles?.name)
                          );
                        }
                        const searchText = searchValue?.toLowerCase().trim();
                        return name?.includes(searchText);
                      }
                    );
                    return (
                      <DataGrid rows={filteredRows || []} columns={columns}>
                        <SearchState
                          value={searchValue}
                          onValueChange={changeSearchValue}
                        />
                        <PagingState defaultCurrentPage={0} pageSize={10} />
                        <IntegratedFiltering />
                        <IntegratedPaging />
                        <RowDetailState defaultExpandedRowIds={[0]} />
                        <Table />
                        <TableHeaderRow />
                        <PagingPanel />
                        <TableRowDetail contentComponent={RowDetail} />
                        <Toolbar />
                        <div
                          className={`${
                            selectedField === "Brand" ||
                            selectedField === "Dealer Name"
                              ? "tableFilter selectbrand"
                              : "tableFilter"
                          }`}
                        >
                          <div className="wrapper">
                            <FieldDropdown
                              fields={columns?.map((column) => column?.title)}
                              selectedField={selectedField}
                              onSelectField={handleFieldChange}
                            />
                            {selectedField === "Brand" ? (
                              <FieldMultipleDropdown
                                fields={Object.keys(brandOptions)}
                                selectedField={selectedFieldMultiple}
                                onSelectField={handleFieldChangeMultiple}
                              />
                            ) : selectedField === "Dealer Name" ? (
                              <DealerNameDropdown
                              fields={[
                                ...new Set(
                                  queryData?.map((row) => row?.profiles?.name).filter(Boolean) || []
                                ),
                              ]}
                              selectedField={selectedFieldMultiple}
                              onSelectField={handleFieldChangeMultiple}
                            />
                            
                            ) : (
                              <SearchPanel />
                            )}
                          </div>
                        </div>
                      </DataGrid>
                    );
                  }}
                </Subscription>
              </div>
            )}
          </Grid>
        </Paper>
      </DashboardLayout>
    </div>
  );
}

DvrReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(DvrReport);
